module.exports = __webpack_public_path__ + "static/media/carousel5.0cb0252e.png";